import { createContext } from "react";

const SystemContext = createContext();

export default SystemContext;